import { loadStripe } from '@stripe/stripe-js';
import { supabase } from '../lib/supabase';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const API_URL = process.env.REACT_APP_API_URL || 'https://remuvr-api.onrender.com';

console.log('Stripe API Configuration:', {
  hasStripeKey: !!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  hasApiUrl: !!process.env.REACT_APP_API_URL
});

export const createCheckoutSession = async (userId, priceId) => {
  try {
    console.log('Creating checkout session:', { userId, priceId });
    
    const stripe = await stripePromise;
    if (!stripe) throw new Error('Stripe failed to initialize');

    // Get the current session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    if (sessionError) {
      console.error('Session error:', sessionError);
      throw sessionError;
    }

    if (!session) {
      console.error('No session found');
      throw new Error('Not authenticated');
    }

    // Make request to our backend API
    const response = await fetch(`${API_URL}/stripe/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      },
      body: JSON.stringify({
        userId,
        priceId
      }),
      mode: 'cors',
      credentials: 'same-origin' 
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create checkout session');
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error('Checkout session error:', error);
    throw error;
  }
};

export const createPortalSession = async (userId) => {
  try {
    // Get the current session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    if (sessionError) throw sessionError;
    if (!session) throw new Error('Not authenticated');

    const response = await fetch(`${API_URL}/stripe/create-portal-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      },
      body: JSON.stringify({ userId }),
      mode: 'cors',
      credentials: 'same-origin' 
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create portal session');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Portal session error:', error);
    throw error;
  }
};
